/* Loaded only by the floor-mat product template and collection FAQ. */
(() => {
  if (window.__ttsFloorMatShippingGuard) return;
  window.__ttsFloorMatShippingGuard = true;
  const dismissConflictingOffer = () => {
    document.querySelectorAll('.react-responsive-modal-root').forEach((root) => {
      if (!root.querySelector('.ecomsend__Modal__Content')) return;
      const text = root.textContent.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      if (!/free\s+shipping|envio\s+(?:gratis|gratuito)/.test(text)) return;
      root.style.setProperty('display', 'none', 'important');
      const close = root.querySelector('.ecomsend__Modal__CloseButton');
      if (close && !root.dataset.ttsShippingDismissed) {
        root.dataset.ttsShippingDismissed = 'true';
        close.click();
      }
    });
  };
  const observer = new MutationObserver(dismissConflictingOffer);
  observer.observe(document.documentElement, {childList: true, subtree: true, characterData: true});
  dismissConflictingOffer();
  window.addEventListener('pagehide', () => observer.disconnect(), {once: true});
})();
